import { CheckOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import { uniqueId } from 'lodash';
import React from 'react';
import { ReactComponent as CustomPlanPromoIcon } from './custom-plan-promo.svg';
import { BillingPlanCardProps } from './use-billing-plans';
import styles from './BillingPlans.module.css';

export const PlanDescription = ({
  option,
  className,
}: {
  option: BillingPlanCardProps;
  className?: string;
}) => (
  <div
    className={classNames(styles.points, className, {
      [styles.customPlan]: option.isCustom,
    })}
  >
    {option.pointsTitle && (
      <div className={styles.pointsTitle}>{option.pointsTitle}</div>
    )}
    {option.points?.map(point => (
      <div
        className={classNames(styles.pointContainer, styles.mainPoint)}
        key={uniqueId(point)}
      >
        <CheckOutlined className={styles.checkIcon} />

        {point}
      </div>
    ))}
    {option.secondaryPoints?.map(point => (
      <div className={styles.pointContainer} key={uniqueId(point)}>
        {!option.isFreeTrial && <CheckOutlined className={styles.checkIcon} />}

        {point}
      </div>
    ))}
    {option.isCustom && (
      <div className={styles.customPromo}>
        <CustomPlanPromoIcon />
        <div>SUPER CAPTURE PIXEL Capture 15% more leads</div>
      </div>
    )}
  </div>
);
